export const ThemePalette = {
	PRIMARY: 'primary',
	SECONDARY: 'secondary',
	TERTIARY: 'tertiary',
	NEUTRAL: 'neutral',
	SUCCESS: 'success',
	ERROR: 'error'
} as const;

export type ThemePalette = (typeof ThemePalette)[keyof typeof ThemePalette];
